<template>
  <form class="w-100" @submit.prevent="submit">
    <div class="row">
      <!--    <div class="col-12 text-left">
            <button v-if="id !== 'new'" @click="del" type="button" class="btn btn-danger">
              حذف اشتراک
              <i class="fas fa-trash"/>
            </button>
            <button type="submit" class="btn btn-success mr-2">
              <span v-if="id !== 'new'">
                بروررسانی اشتراک
              <i class="far fa-save"/>
              </span>
              <span v-else>
                ذخیره اشتراک جدید
                    <i class="fas fa-plus"/>
              </span>
            </button>

            <hr>
          </div>-->
      <div v-if="id === 'new'  || (id !== 'new' && Object.keys(item).length > 0 )" class="col-12">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-3">
            <StatsCard>
              <div class="icon-big text-center icon-info" slot="header">
                <i class="fas fa-unlock-alt"/>
              </div>
              <div class="text-center" slot="content">
                <p>تاریخ ایجاد</p>
                {{$dateTimeFormat(item.created_at)}}
              </div>
            </StatsCard>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <StatsCard>
              <div :class="`icon-big text-center icon-${item.is_verified ? 'success' : 'danger' }`"
                   slot="header">
                <i v-if="item.is_verified" class="far fa-check-circle"/>
                <i v-else class="far fa-check-circle"/>
              </div>
              <div class="text-right" slot="content">
                <p><b>وضعیت</b></p>
                <div v-if="item.is_verified">پرداخت شده</div>
                <div v-else>پرداخت نشده</div>
              </div>
            </StatsCard>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <StatsCard>
              <div class="icon-big text-center icon-info" slot="header">
                <i class="far fa-user"/>
              </div>
              <div class="text-center" slot="content">
                <p>کاربر</p>
                <router-link :to="{name: 'edit_user' , params: {id : item.account_id}}">{{user.username}}</router-link>
              </div>
            </StatsCard>
          </div>
          <div class="col-12">
            <card class="card" title="اطلاعات پایه">
              <div>
                <div class="form-row">
                  <div class="col-12 col-lg-4 mb-3 text-center font-16">
                    <div class="mb-1 text-secondary">مبلغ بدون تخفیف</div>
                    <div>{{$priceMask(item.price)}} {{item.currency || 'ریال'}}</div>
                  </div>
                  <div v-if="item.discount_price" class="col-12 col-lg-4 mb-3 text-center font-16">
                    <div class="mb-1 text-secondary">مبلغ تخفیف</div>
                    <div>{{$priceMask(item.discount_price)}} {{item.currency || 'ریال'}}</div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3 text-center font-16">
                    <div class="mb-1 text-secondary">مبلغ نهایی</div>
                    <div>{{$priceMask(item.final_price)}} {{item.currency || 'ریال'}}</div>
                  </div>

                  <div class="clearfix"/>
                </div>
              </div>
            </card>
          </div>
          <div class="col-12">
            <card class="card" title="سبد خرید">
              <div v-for="(val , index) in item.cart" class="d-flex align-items-center">
                <div>
                  محصول {{index + 1}}
                </div>
                <div style="flex: 1" class="row">
                  <div class="col-12 col-lg-4 mb-3 text-center font-16">
                    <div class="mb-1 text-secondary"> نوع</div>
                    <div v-if="val.type === 'PLAN'">اشتراک</div>
                    <div v-if="val.type === 'CHARGE'">شارژ</div>
                  </div>
                  <div v-if="val.product && val.product.title" class="col-12 col-lg-4 mb-5 text-center font-16">
                    <div class="mb-1 text-secondary">عنوان محصول</div>
                    <div>{{val.product.title}}</div>
                  </div>
                  <div v-if="val.price" class="col-12 col-lg-4 mb-5 text-center font-16">
                    <div class="mb-1 text-secondary">قیمت محصول</div>
                    <div>{{$priceMask(val.price)}} {{val.product.currency || 'ریال'}}</div>
                  </div>
                  <div v-if="val.discount_percent" class="col-12 col-lg-4 mb-5 text-center font-16">
                    <div class="mb-1 text-secondary">درصد تخفیف</div>
                    <div>{{val.discount_percent}}</div>
                  </div>
                  <div v-if="val.final_price" class="col-12 col-lg-4 mb-5 text-center font-16">
                    <div class="mb-1 text-secondary">قیمت نهایی</div>
                    <div>{{$priceMask(val.final_price)}} {{val.product.currency || 'ریال'}}</div>
                  </div>
                  <div v-if="val.extra && val.extra.days_count" class="col-12 col-lg-4 mb-5 text-center font-16">
                    <div class="mb-1 text-secondary">مدت زمان اشتراک</div>
                    <div>{{val.extra.days_count}} روز</div>
                  </div>

                  <div v-if="val.extra && val.extra.start_time" class="col-12 col-lg-4 mb-5 text-center font-16">
                    <div class="mb-1 text-secondary">زمان شروع اشتراک</div>
                    <div>{{$dateTimeFormat(val.extra.start_time)}}</div>
                  </div>
                  <div v-if="val.extra && val.extra.expiration_time" class="col-12 col-lg-4 mb-5 text-center font-16">
                    <div class="mb-1 text-secondary">زمان اتمام اشتراک</div>
                    <div>{{$dateTimeFormat(val.extra.expiration_time)}}</div>
                  </div>
                  <div v-if="item.cart.length !== -1 && item.cart.length !== index + 1" class="col-12">
                    <hr/>
                  </div>
                  <div class="clearfix"/>

                </div>
              </div>
            </card>
          </div>
        </div>


      </div>
    </div>
  </form>
</template>
<script>
  import Modela from 'modela';
import { mapActions } from "vuex";
import StatsCard from "../../components/Cards/StatsCard";
import orderModel from "../../models/order";
import userModel from "../../models/users";

  export default {
    name: 'order_edit',
    components: {StatsCard},
    data() {
      const {params} = this.$route
      const {id} = params
      return {
        ...mapActions('main', [
          'crud'
        ]),
        id,
        item: {},
        user: {},
      }
    },
    computed: {},
    methods: {
      async getData() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const order = await this.crud({
            action: 'get',
            section: 'orders',
            id: this.id,
            showError: true
          })

          const result = order.data
          let item = new Modela(orderModel)
          item = item.$set(result)
          this.item = item.$clean().$export()
          await this.getUserData()
        } catch (e) {
          console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
      async getUserData() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const user = await this.crud({
            action: 'get',
            section: 'accounts',
            id: this.item.account_id,
            showError: true
          })
          if (user.data) {
            const result = user.data
            let item = new Modela(userModel)
            item = item.$clean()
            item = item.$set(result)
            this.user = item.$clean().$export()

            if (item.mobile) {
              const mobileArr = item.mobile.match(/[^()]+/g)
              if (mobileArr.length === 2) {
                this.countryCode = mobileArr[0]
                this.user.mobile = mobileArr[1]
              }
            }
          }
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
    },
    // async post() {
    //   try {
    //     this.$store.commit('main/SET', {key: 'loading', value: true})
    //     const newPlan = await this.crud({
    //       action: 'post',
    //       section: 'plans',
    //       data: this.item,
    //       showError: true
    //     })
    //     await this.$successAlert()
    //     // this.$router.go(-1)
    //     await this.$router.push({name: 'plans'})
    //   } catch (e) {
    //     // console.log(e)
    //   } finally {
    //     this.$store.commit('main/SET', {key: 'loading', value: false})
    //   }
    //
    // },
    // async put() {
    //   try {
    //     this.$store.commit('main/SET', {key: 'loading', value: true})
    //     const updatePlan = await this.crud({
    //       action: 'put',
    //       section: 'plans',
    //       id: this.id,
    //       data: this.item,
    //       showError: true
    //     })
    //     this.$successAlert()
    //     // this.$router.go(-1)
    //     await this.$router.push({name: 'plans'})
    //   } catch (e) {
    //     // console.log(e)
    //   } finally {
    //     this.$store.commit('main/SET', {key: 'loading', value: false})
    //   }
    //
    // },
    // async del() {
    //   if (!await this.$confirmAlert())
    //     return false
    //   try {
    //     this.$store.commit('main/SET', {key: 'loading', value: true})
    //     const deleted = await this.crud({
    //       action: 'delete',
    //       section: 'plans',
    //       id: this.id,
    //       showError: true
    //     })
    //     await this.$successAlert()
    //     await this.$router.push({name: 'plans'})
    //     // this.$router.go(-1)
    //   } catch (e) {
    //     // console.log(e)
    //   } finally {
    //     this.$store.commit('main/SET', {key: 'loading', value: false})
    //   }
    // },
    // async submit() {
    //   if (this.id !== 'new')
    //     this.put()
    //   else
    //     this.post()
    // },
    // },
    async created() {
      // if (this.id !== 'new')
      await this.getData()
      // else {
      //   let item = new Modela(planModel)
      //   this.item = item.$clean().$export()
      // }
    }
  }
</script>
